// @flow
import React, { Component } from 'react';
import getMatchedMedia from './getMatchedMedia';
import addMediaListener from './addMediaListener';

export default function withMediaListener(WrappedComponent) {
  class MediaListenerWrapper extends Component {
    static OriginalComponent;
    removeListener;

    componentDidMount() {
      this.removeListener = addMediaListener(() => this.forceUpdate(), false);
    }
    componentWillUnmount() {
      this.removeListener();
    }
    render() {
      return (
        <WrappedComponent
          {...{
            ...this.props,
            matchedMedia: getMatchedMedia(),
          }}
        />
      );
    }
  }

  MediaListenerWrapper.OriginalComponent = WrappedComponent;
  MediaListenerWrapper.defaultProps = WrappedComponent.defaultProps;
  MediaListenerWrapper.propTypes = WrappedComponent.propTypes;
  MediaListenerWrapper.displayName = `withMediaListener(${WrappedComponent.displayName ||
    WrappedComponent.name})`;

  return MediaListenerWrapper;
}
